import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=5a3ec83f"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import "./AppHeaderDropdownAccnt.vue?vue&type=style&index=0&id=5a3ec83f&lang=scss"

import exportComponent from "/Users/mirox/Desktop/coreui-free-vue-admin-template-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__